import React, { Fragment } from 'react'; // eslint-disable-line
import Tooltip from 'rc-tooltip';

class OnOffSwitch extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isToggleOn: props.isToggleOn };
        this.handleChange = this.handleChange.bind(this);
        this.handleExtChange = this.handleExtChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isToggleOn !== this.props.isToggleOn) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ isToggleOn: !!this.props.isToggleOn });
        }
    }

    handleChange(e) {
        this.props.onChange(e);
        this.setState((prevState) => { return { isToggleOn: !prevState.isToggleOn }; });
    }

    handleExtChange() {
        this.moduleToggle.click();
    }

    render() {
        const {
            buttonClass,
            name,
            id,
            disabled,
            tooltipText,
        } = this.props;

        const chk = (
            <>
                <input
                    id={id}
                    type="checkbox"
                    onChange={this.handleChange}
                    name={name}
                    defaultValue={!!this.state.isToggleOn}
                    checked={!!this.state.isToggleOn}
                    ref={(input) => { this.moduleToggle = input; }}
                    disabled={disabled}
                    data-qa={`toggle-for-${this.props.dataQA ? this.props.dataQA : name}`}
                    style={disabled ? { pointerEvents: 'none' } : {}}
                />
                <label><span /></label>
            </>
        );
        return (
            // eslint-disable-next-line
            <div className={`module__toggle ${tooltipText && disabled ? 'help-tooltip ' : ''} ${buttonClass}`} onClick={this.handleClick}>
                <div className="toggle checkbox" aria-label={tooltipText}>
                    {tooltipText && disabled // eslint-disable-next-line
                        ?
                        (
                            <div id={`tooltip-holder-for-${name}`}>
                                <Tooltip
                                    placement="bottom"
                                    trigger="[hover, focus]"
                                    mouseEnterDelay={0}
                                    mouseLeaveDelay={0.1}
                                    overlay={<span>{tooltipText}</span>}
                                >
                                    <span style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}>
                                        {chk}
                                    </span>
                                </Tooltip>
                            </div>
                        )
                        : (chk)}
                </div>
            </div>
        );
    }
}

export default OnOffSwitch;
